"use strict";
var concat_1 = require('../operator/concat');
exports.concat = concat_1.concatStatic;
//# sourceMappingURL=concat.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/~/rxjs/observable/concat.js
// module id = ../../../../rxjs/observable/concat.js
// module chunks = 3